import TomSelect from "tom-select";
import CaptchaInitializer from "../../../Scalesoft.Shared.FrontEnd/Scripts/Captcha/CaptchaInitializer";
import {NotificationType} from "../../../Scalesoft.Shared.FrontEnd/Scripts/Enums/NotificationType";
import ErrorHandler from "../../../Scalesoft.Shared.FrontEnd/Scripts/Error-Handler/ErrorHandler";
import GuiCommonShared from "../../../Scalesoft.Shared.FrontEnd/Scripts/GuiCommonShared";
import NotificationConfiguration from "../../../Scalesoft.Shared.FrontEnd/Scripts/NotificationConfiguration";
import {ContactVerificationType} from "../Enums/ContactVerificationType";
import {MethodContactType} from "../Enums/MethodContactType";
import InputFormat from "../InputFormat";
import ApiClient from "../Registration/ApiClient";
import IEmailViewModel from "../Registration/Interfaces/IEmailViewModel";
import IPhoneNumberViewModel from "../Registration/Interfaces/IPhoneViewModel";
import IPostalAddressViewModel from "../Registration/Interfaces/IPostalAddressViewModel";
import ContactApiClient from "./ContactApiClient";
import ContactUtils from "./ContactUtils";
import ContactValidation from "./ContactValidation";
import {ContactType} from "./Enums/ContactType";

declare const methodType: MethodContactType;

export default class ContactCard {
    private readonly contactType: ContactType;
    private cardJq: JQuery;
    private readonly registerFormEl: JQuery;
    private readonly contactDialogsContainer: JQuery;
    private readonly apiClient: ApiClient;
    private readonly contactApiClient: ContactApiClient;
    private readonly captchaInitializer: CaptchaInitializer;
    private readonly formatInput: InputFormat;
    private readonly cardIndex: number;
    private readonly verifyContactModal = jq("#verifyContactModal");
    private readonly guiCommon: GuiCommonShared;
    private readonly errorHandler: ErrorHandler;
    private readonly validateContactCallback: (contactType: ContactType, oldId: number, newId: number, response: JQuery.jqXHR) => any;
    private readonly updateContactCountCallback: (contactType: ContactType, contactsRow, response?: JQuery.jqXHR) => any;
    private readonly onDeleteCallback: (contactType: ContactType, id: number) => any;
    private readonly onAddressEditCallback: (response: JQuery.jqXHR) => any;
    private readonly mOnCardAdded: (cardEl: JQuery) => void;
    private readonly mLocalization: Localization;
    private readonly cardViewModelPrefix: string;

    private emailModel: IEmailViewModel;
    private phoneNumberModel: IPhoneNumberViewModel;
    private postalAddressModel: IPostalAddressViewModel;
    private readonly contactMethodType: MethodContactType;
    private readonly updateContactsOnFormSubmit: boolean;
    private readonly existingContactDeletedCallback: (contactId: number) => void;

    constructor(contactType: ContactType,
                cardJq: JQuery,
                registerFormEl: JQuery,
                contactDialogsContainer: JQuery,
                registrationApiClient: ApiClient,
                inputFormat: InputFormat,
                cardIndex: number,
                contactApiClient: ContactApiClient,
                captchaInitializer: CaptchaInitializer,
                validateContactCallback: (contactType: ContactType, oldId: number, newId: number, response: JQuery.jqXHR) => any,
                updateContactCountCallback: (contactType: ContactType, contactsRow: JQuery, response: JQuery.jqXHR) => any,
                guiCommon: GuiCommonShared,
                errorHandler: ErrorHandler,
                localization: Localization,
                onDeleteCallback: (contactType: ContactType, id: number) => any,
                onAddressEditCallback: (response: JQuery.jqXHR) => any,
                cardViewModelPrefix: string,
                updateContactsOnFormSubmit: boolean,
                existingContactDeletedCallback: (contactId: number) => void,
                onCardAdded: (cardEl: JQuery) => void = null,
    ) {
        this.contactType = contactType;
        this.cardJq = cardJq;
        this.registerFormEl = registerFormEl;
        this.contactDialogsContainer = contactDialogsContainer;
        this.apiClient = registrationApiClient;
        this.formatInput = inputFormat;
        this.cardIndex = cardIndex;
        this.contactApiClient = contactApiClient;
        this.captchaInitializer = captchaInitializer;
        this.validateContactCallback = validateContactCallback;
        this.updateContactCountCallback = updateContactCountCallback;
        this.guiCommon = guiCommon;
        this.errorHandler = errorHandler;
        this.mLocalization = localization;
        this.onDeleteCallback = onDeleteCallback;
        this.onAddressEditCallback = onAddressEditCallback;
        this.mOnCardAdded = onCardAdded;
        this.cardViewModelPrefix = cardViewModelPrefix;
        const methodTypeDataAttributeVal = this.cardJq.attr("data-contact-method-type");
        if (methodTypeDataAttributeVal !== "") {
            this.contactMethodType = parseInt(methodTypeDataAttributeVal, 10);
        } else {
            this.contactMethodType = null;
        }

        this.updateContactsOnFormSubmit = updateContactsOnFormSubmit;
        this.existingContactDeletedCallback = existingContactDeletedCallback;
    }

    public init(): void {
        this.initDeleteButton();
        this.initEditButton();
        this.initVerifyButton();

        this.cardJq.on("contact-changed", (event, formContainer: HTMLElement) => {
            this.replaceContactCard(jq(formContainer));
        });
    }

    public insertCard(): void {
        const row = this.registerFormEl.find(`.${this.contactType}-row`);
        this.cardJq.insertBefore(row.children(".add-contact"));
        if (this.mOnCardAdded !== null) {
            this.mOnCardAdded(this.cardJq);
        }
    }

    public setEmailModel(model: IEmailViewModel): void {
        this.emailModel = model;
    }

    public setPhoneNumberModel(model: IPhoneNumberViewModel): void {
        this.phoneNumberModel = model;
    }

    public setPostalAddressModel(model: IPostalAddressViewModel): void {
        this.postalAddressModel = model;
    }

    private handleAddContactVisibility(): void {
        const addContactEl: JQuery<HTMLElement> = this.cardJq.parents(".contact-row").find(".add-contact");
        if (addContactEl.hasClass("d-none")) {
            addContactEl.removeClass("d-none");
        }
    }

    private initDeleteButton(): void {
        const deleteContactDialog = jq("#delete-contact");

        deleteContactDialog.on("hide.bs.modal", () => {
            deleteContactDialog.find(".deleted-contact-card").empty();
        });

        this.cardJq.find(".delete-btn-dialog").on("click", (event) => {
            event.preventDefault();

            const deletedContactCard = this.cardJq.clone();
            deletedContactCard.attr("class", "tile my-2 px-4 d-inline-block");
            deletedContactCard.find("button").remove();
            deleteContactDialog.find(".deleted-contact-card").empty().append(deletedContactCard);

            const confirmDeleteBtn = deleteContactDialog.find(".delete-btn");
            const alertContainer = deleteContactDialog.find(".alert-container");
            this.guiCommon.destroyNotification(alertContainer);

            confirmDeleteBtn.off("click");
            confirmDeleteBtn.on("click", (clickEvent) => {
                ContactUtils.handleLoading(deleteContactDialog, true, ".delete-loading", ".delete-btn");

                clickEvent.preventDefault();
                const contactRow = this.cardJq.parents(".contact-row");
                const userId = this.getUserId();

                if (this.contactType === ContactType.Address) {
                    if (methodType === MethodContactType.Permanent) {
                        const promise = this.contactApiClient.deleteAddress(userId, this.cardJq.find(".address-id").val() as number);
                        promise.done((response) => {
                            if (response.success) {
                                this.cardJq.remove();
                                this.updateContactCountCallback(ContactType.Address, contactRow, response);
                            }
                            deleteContactDialog.modal("hide");

                        });

                        promise.always(() => {
                            this.guiCommon.destroyNotification(alertContainer);
                            ContactUtils.handleLoading(deleteContactDialog, false, ".delete-loading", ".delete-btn");
                        });

                        promise.fail(() => {
                            this.mLocalization.translateAsync("failed-delete-address", "PostalAddressViewModel").then((defaultMessage) => {
                                const notificationConfig = new NotificationConfiguration({
                                    container: alertContainer,
                                    messages: this.errorHandler.getErrorText(promise as JQueryXHR, defaultMessage.result.value),
                                    notificationType: NotificationType.Danger,
                                });

                                this.guiCommon.showNotification(notificationConfig);
                            });

                        });
                    } else {
                        this.cardJq.remove();
                        this.guiCommon.destroyNotification(alertContainer);
                        deleteContactDialog.modal("hide");
                    }

                    return;
                }
                const id = this.getContactId();

                const requestCallback = () => {
                    if (this.updateContactsOnFormSubmit) {
                        this.removeClonedInputs();
                        this.handleAddContactVisibility();
                        this.cardJq.remove();
                        this.updateContactCountCallback(this.contactType, contactRow);
                        this.onDeleteCallback(this.contactType, id);
                        jq(document.documentElement).trigger("contacts-changed");
                        deleteContactDialog.modal("hide");
                        this.guiCommon.destroyNotification(alertContainer);
                        ContactUtils.handleLoading(deleteContactDialog, false, ".delete-loading", ".delete-btn");
                        if (!isNaN(id)) {
                            this.existingContactDeletedCallback(id);
                        }

                        return;
                    }

                    if (!this.updateContactsOnFormSubmit) {
                        const ajax = this.contactApiClient.deleteContact(id, userId, this.contactMethodType);

                        ajax.done((response) => {
                            if (response.success) {
                                this.handleAddContactVisibility();
                                this.cardJq.remove();
                                this.updateContactCountCallback(this.contactType, contactRow, response);
                                this.onDeleteCallback(this.contactType, id);
                                jq(document.documentElement).trigger("contacts-changed");
                                deleteContactDialog.modal("hide");
                            }
                        });

                        ajax.always(() => {
                            this.guiCommon.destroyNotification(alertContainer);
                            ContactUtils.handleLoading(deleteContactDialog, false, ".delete-loading", ".delete-btn");
                        });

                        ajax.fail(() => {
                            const notificationConfig = new NotificationConfiguration({
                                notificationType: NotificationType.Danger,
                                messages: this.errorHandler.getErrorText(ajax as JQueryXHR),
                                container: alertContainer,
                            });

                            this.guiCommon.showNotification(notificationConfig);

                            this.captchaInitializer.prepareContainer(jq, deleteContactDialog);
                        });
                    }
                };

                requestCallback();
            });
        });
    }

    private getUserId(): number {
        const id = jq(".contact-dialogs #user-id").val() as string;
        return parseInt(id, 10);
    }

    private getContactId(): number {
        switch (this.contactType) {
            case ContactType.Email:
                return this.emailModel.id;
            case ContactType.PhoneNumber:
                return this.phoneNumberModel.id;
            default:
                return null;
        }
    }

    private initEditButton(): void {
        this.cardJq.find(".edit-btn").on("click", (event) => {
            event.preventDefault();
            let editorDialog: JQuery;
            switch (this.contactType) {
                case ContactType.Address: {
                    editorDialog = this.contactDialogsContainer.find("#addPostalAddressForm");
                    this.mLocalization.translateAsync("edit-address", "PostalAddressViewModel").then((value) => {
                        editorDialog.find(".modal-title").text(value.result.value);
                    });
                    editorDialog.find("#PostalAddressContactType").val(this.postalAddressModel.type);
                    editorDialog.find("#PostalAddressContactName").val(this.postalAddressModel.name);
                    editorDialog.find("#Street").val(this.postalAddressModel.street);
                    editorDialog.find("#PostalCode").val(this.postalAddressModel.postalCode);
                    editorDialog.find("#City").val(this.postalAddressModel.city);
                    editorDialog.find("#Country").val(this.postalAddressModel.country);
                    editorDialog.find("#index").val(this.cardJq.index());
                    editorDialog.find(".address-id").val(this.postalAddressModel.id);
                    break;
                }

                case ContactType.Email: {
                    editorDialog = this.contactDialogsContainer.find("#addEmailForm");
                    this.mLocalization.translateAsync("edit-email", "ContactViewModel").then((value) => {
                        editorDialog.find(".modal-title").text(value.result.value);
                    });
                    editorDialog.find("#EmailContactName").val(this.emailModel.name);
                    editorDialog.find("#EmailContactType").val(this.emailModel.group);
                    editorDialog.find("#Email").val(this.emailModel.email);
                    editorDialog.find("#index").val(this.emailModel.index);
                    editorDialog.find("#EmailId").val(this.emailModel.id);
                    if (this.emailModel.contactVerificationType === ContactVerificationType.ByAdministrator) {
                        editorDialog.find(".is-contact-verified").prop("checked", this.emailModel.isContactVerified);
                        editorDialog.find(".is-contact-verified").parent(".form-check").removeClass("d-none");
                    } else {
                        editorDialog.find(".is-contact-verified").parent(".form-check").addClass("d-none");
                    }

                    editorDialog.find(".verification-type").val(this.emailModel.contactVerificationType);
                    break;
                }

                case ContactType.PhoneNumber: {
                    editorDialog = this.contactDialogsContainer.find("#addPhoneNumberForm");
                    this.mLocalization.translateAsync("edit-phone-number", "ContactViewModel").then((value) => {
                        editorDialog.find(".modal-title").text(value.result.value);
                    });
                    const areaCode = this.phoneNumberModel.phoneNumber.split(" ").join("").slice(0, -9);
                    const countrySelect = editorDialog.find(".phone-number-select");
                    let phoneNumberCountryOpt = countrySelect.find(`option[data-country-prefix="${areaCode}"]`);
                    if (phoneNumberCountryOpt.length === 0) {
                        phoneNumberCountryOpt = countrySelect.find("option").first();
                    }
                    (countrySelect.get(0) as HTMLSelectElement & { tomselect: TomSelect }).tomselect.addItem(phoneNumberCountryOpt.val().toString());
                    editorDialog.find("#PhoneContactName").val(this.phoneNumberModel.name);
                    editorDialog.find("#PhoneContactType").val(this.phoneNumberModel.group);
                    editorDialog.find("#PhoneNumber").val(this.phoneNumberModel.phoneNumber);
                    editorDialog.find("#index").val(this.phoneNumberModel.index);
                    editorDialog.find("#PhoneId").val(this.phoneNumberModel.id);

                    if (this.phoneNumberModel.contactVerificationType === ContactVerificationType.ByAdministrator) {
                        editorDialog.find(".is-contact-verified").prop("checked", this.phoneNumberModel.isContactVerified);
                        editorDialog.find(".is-contact-verified").parent(".form-check").removeClass("d-none");
                    } else {
                        editorDialog.find(".is-contact-verified").parent(".form-check").addClass("d-none");
                    }

                    editorDialog.find(".verification-type").val(this.phoneNumberModel.contactVerificationType);
                    break;
                }
            }
            editorDialog.modal("show");
        });

    }

    private replaceContactCard(formContainer: JQuery): void {
        let ajax;
        switch (this.contactType) {
            case ContactType.Address: {
                const model: IPostalAddressViewModel = {
                    type: formContainer.find("#PostalAddressContactType").val() as string,
                    name: formContainer.find("#PostalAddressContactName").val() as string,
                    street: formContainer.find("#Street").val() as string,
                    postalCode: formContainer.find("#PostalCode").val() as string,
                    city: formContainer.find("#City").val() as string,
                    country: formContainer.find("#Country").val() as string,
                    id: formContainer.find(".address-id").val() as number,
                };

                if (methodType === MethodContactType.Permanent) {
                    const formJq = formContainer.find("#postalAddressForm");
                    formJq.find(".user-data-select-input")
                        .val(formJq.find("#PostalAddressContactType").val() as string);

                    ajax = this.contactApiClient.editAddress(this.getUserId(), formJq);
                    ajax.done((response) => {
                        model.id = response.id;
                        this.replaceAddressCard(model);
                        formContainer.modal("hide");
                        this.onAddressEditCallback(response);
                    });

                    ajax.always(() => {
                        ContactUtils.handleLoading(formContainer, false, ".delete-loading", ".delete-btn");
                    });

                    ajax.fail((response) => {
                        formContainer.find(".modal-body .alert-container")
                            .html(`<span class="text-danger">${response}</span>`)
                            .show();
                    });
                } else {
                    formContainer.modal("hide");
                    ContactUtils.handleLoading(formContainer, false, ".delete-loading", ".delete-btn");
                    this.replaceAddressCard(model);
                }
                return;
            }

            case ContactType.Email: {
                const contactId = formContainer.find("#EmailId").val() as string;
                const model: IEmailViewModel = {
                    group: formContainer.find("#EmailContactType").val() as string,
                    name: formContainer.find("#EmailContactName").val() as string,
                    email: formContainer.find("#Email").val() as string,
                    id: parseInt(contactId, 10),
                    userId: jq(".contact-dialogs #user-id").val() as string,
                    index: parseInt(formContainer.find("#index").val() as string, 10),
                    isContactVerified: formContainer.find(".is-contact-verified").is(":checked"),
                    confirmCode: this.cardJq.find(".contact-confirm-code").val() as string,
                    contactVerificationType: ContactVerificationType[this.cardJq.find(".verification-type").val() as string],
                };
                this.emailModel = model;
                ajax = this.contactApiClient.getEmailCard(model, this.cardIndex, this.cardViewModelPrefix, this.contactMethodType);
                break;
            }

            case ContactType.PhoneNumber: {
                const contactId = formContainer.find("#PhoneId").val() as string;
                const model: IPhoneNumberViewModel = {
                    group: formContainer.find("#PhoneContactType").val() as string,
                    name: formContainer.find("#PhoneContactName").val() as string,
                    phoneNumber: formContainer.find("#PhoneNumber").val() as string,
                    id: parseInt(contactId, 10),
                    userId: jq(".contact-dialogs #user-id").val() as string,
                    index: parseInt(formContainer.find("#index").val() as string, 10),
                    isContactVerified: formContainer.find(".is-contact-verified").is(":checked"),
                    confirmCode: this.cardJq.find(".contact-confirm-code").val() as string,
                    contactVerificationType: ContactVerificationType[this.cardJq.find(".verification-type").val() as string],
                };
                this.phoneNumberModel = model;
                ajax = this.contactApiClient.getPhoneCard(model, this.cardIndex, this.cardViewModelPrefix, this.contactMethodType);
                break;
            }
        }

        ajax.done((response) => {
            const responseCard = jq(response);
            this.cardJq.replaceWith(responseCard);
            this.cardJq = responseCard;
            this.init();
            formContainer.modal("hide");
        });

        ajax.fail((response) => {
            formContainer.find(".modal-body").prepend(`<span class="text-danger">${response}</span>`);
        });

        ajax.always(() => {
            this.guiCommon.destroyNotification(formContainer.find(".alert-container"));
            ContactUtils.handleLoading(formContainer, false, ".delete-loading", ".delete-btn");
        });
    }

    private initVerifyButton(): void {
        this.cardJq.find(".verify-contact-btn").on("click", (event: JQuery.ClickEvent) => {
            event.preventDefault();
            const contactValue = this.cardJq.find(".contact-value").text();
            this.verifyContactModal.find("#verified-contact").val(contactValue);

            const contactId = parseInt(this.cardJq.find(".contact-id").val() as string, 10);

            const contactType = jq(event.currentTarget).attr("data-contact-type");
            const contactValidation = new ContactValidation(
                contactType,
                contactId,
                this.onVerification.bind(this),
                this.captchaInitializer,
                this.guiCommon,
                this.errorHandler,
                this.mLocalization,
            );
            contactValidation.main();
        });
    }

    private onVerification(oldId: number, newId: number, confirmCode: string, response: JQuery.jqXHR): void {
        this.cardJq.find(".non-verified-message").addClass("hidden");
        this.cardJq.find(".verified-message").removeClass("hidden");
        this.cardJq.find(".contact-confirm-code").val(confirmCode);
        this.cardJq.find(".selected-for-verification-selector").prop("checked", true);
        this.cardJq.find(".verified-selector").prop("checked", true);
        this.cardJq.find(".contact-id").val(newId);
        this.cardJq.attr("id", newId);
        this.validateContactCallback(this.contactType, oldId, newId, response);
        switch (this.contactType) {
            case ContactType.Email:
                this.emailModel.id = newId ? newId : this.emailModel.id;
                this.emailModel.confirmCode = confirmCode;
                break;
            case ContactType.PhoneNumber:
                this.phoneNumberModel.id = newId ? newId : this.phoneNumberModel.id;
                this.phoneNumberModel.confirmCode = confirmCode;
                break;
        }
    }

    private replaceAddressCard(model: IPostalAddressViewModel): void {
        this.postalAddressModel = model;

        this.mLocalization.translateAsync(model.type, "address-type")
            .then((typeTranslation) => {
                this.cardJq.find(".contact-type").text(typeTranslation.result.value)
                    .val(model.type);
            });

        this.cardJq.find(".contact-name").text(model.name).val(model.name);
        this.cardJq.find(".contact-street").text(model.street).val(model.street);
        this.cardJq.find(".contact-code").text(model.postalCode).val(model.postalCode);
        this.cardJq.find(".contact-city").text(model.city).val(model.city);
        this.cardJq.find(".contact-country").text(model.country).val(model.country);
    }

    private removeClonedInputs(): void {
        const inputs = this.cardJq.find("input");
        const parentForm = this.cardJq.parents("form");
        inputs.each((index, element) => {
            const elementJq = jq(element);
            const inputName = elementJq.attr("name");
            parentForm.find(`[name="${inputName}"]`).remove();
        });
    }
}
